import React from 'react'
import { Button, Form, Grid, Checkbox, Header, Image, Message, Segment } from 'semantic-ui-react'

const Registro = () => (
  <Grid    style={{ height: '90vh' }} >
    <Grid.Column >
      <Header as='h2'   textAlign='center'>
         Registro Quality Academics     
      </Header>
        <Form size='huge'  >
            <Segment stacked>
            <Form.Field>
              <label >First Name</label>
              <input placeholder='First Name' />
            </Form.Field>
            <Form.Field>
              <label>Last Name</label>
              <input placeholder='Last Name' />
            </Form.Field>
            <Form.Field>
              <Checkbox label='I agree to the Terms and Conditions' />
            </Form.Field>
            <Button color='instagram' fluid size='large'>
            Registro
          </Button>
            </Segment>
      </Form>
 
       
    </Grid.Column>
    
    
  </Grid>
)

export default Registro